import { EngagementDefinition } from '../base/EngagementDefinition';
import {
  EngagementType,
  SlidesAdminConfig,
  SlidesAdminData,
} from '@/generated/graphql';
import { StageSlidesEngagement } from './stage/stage-view';
import { FanSlidesEngagement } from './fan/mobile-view';
import { CardStackIcon } from '@radix-ui/react-icons';
import { SlidesEditorView } from './admin/editor-view';
import { SlidesControlView } from './admin/control-view';
import { DEFAULT_SLIDE_DURATION_MS } from './consts';

export const slidesEngagementDefinition: EngagementDefinition<
  SlidesAdminConfig,
  SlidesAdminData
> = {
  enabled: true,
  title: 'Slides',
  Icon: CardStackIcon,
  type: EngagementType.Slides,
  stageComponent: StageSlidesEngagement,
  fanComponent: FanSlidesEngagement,
  adminEditorView: SlidesEditorView,
  adminControlView: SlidesControlView,
  getInitialData: () => ({
    currentSlide: '',
    slidesDisplayOrder: [],
  }),
  getInitialConfig: () => ({
    autoPlay: false,
    autoPlayIntervalMs: DEFAULT_SLIDE_DURATION_MS,
  }),
};
